import React from 'react'

const Product = () => {
    return (
        <div>
            <h1>
                this is Product</h1>
        </div>
    )
}

export default Product
